// Static tokens for StyleX - these must be static string literals
// Spacing values (in pixels)
export const space = {
    0: '0',
    1: '4px',
    2: '8px',
    3: '12px',
    4: '16px',
    5: '20px',
    6: '24px',
    7: '28px',
    8: '32px',
    9: '36px',
    10: '40px',
    11: '44px',
    12: '48px',
    13: '52px',
    14: '56px',
    15: '60px',
    16: '64px',
    17: '68px',
    18: '72px',
    19: '76px',
    20: '80px',
};

// Container sizes (in pixels)
export const containerSizes = {
    1: '448px',
    2: '688px',
    3: '880px',
    4: '1136px',
    5: '1200px',
    6: '1400px',
};

// Gap values (in pixels)
export const gap = {
    1: '4px',
    2: '8px',
    3: '12px',
    4: '16px',
    5: '20px',
    6: '24px',
    7: '28px',
    8: '32px',
    9: '36px',
}; 